export default __webpack_public_path__ + "static/media/training.3d7906ed.jpg";